import moment from 'moment';

const formatMonthDate = date => {
  return date ? moment(date).format('MMM YYYY') : '';
};

export default formatMonthDate;
